import { render, staticRenderFns } from "./MyAccount.vue?vue&type=template&id=9c9c30f0&scoped=true&"
import script from "./MyAccount.vue?vue&type=script&async=true&lang=js&"
export * from "./MyAccount.vue?vue&type=script&async=true&lang=js&"
import style0 from "./MyAccount.vue?vue&type=style&index=0&id=9c9c30f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9c30f0",
  null
  
)

export default component.exports